import { useRejectInvitationMutation } from './__generated__/rejectInvite.generated';
import { GetInvitationsDocument } from './__generated__/getInvitations.generated';

export const useRejectInvitation = () => {
	const [rejectInvitation] = useRejectInvitationMutation({
		refetchQueries: [GetInvitationsDocument],
	});

	return rejectInvitation;
};
